module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAA9ElEQVQokYXROy7EYRQF8N+IsAIarwVQeAWtiY4NmI4CpW62wgpmA3QeG5hIyFiAMJVaMTRy5E7yp3GSm9zHOfe7936tbrerMIUzHGKlcgP0cIHPJCarMIcrrPqNnbIjHGA4UZ3H5D7eG5L4/apdYzovnDbIe5jHHVrYxRtusYGTCDrVbbHIz2hXLv4yFiruRLBewWx1bhcxCPkeMxWvTfxZsvVP/BXBQ2PBzDweI5az5sXxIQYR5M7BSy0YYkbLKPFfqxb0ssMljrGJGyw1Zo4o5NSewo1ghP36ixSaiDD2WJzReOkhtnFe//FRFj+5rR8OvgH5pDc9jy8aUQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newimg/outReName.png
// module id = n8DO
// module chunks = 32